import PropTypes from "prop-types"

import Modal from "shared/components/modal"

import styles from "shared/components/web_modal.module.scss"

const MakeItYourOwnModal = ({ visible, onClose, onConvert, onCancel }) => {
  const onCancelInternal = () => {
    onCancel?.()
    onClose()
  }

  return (
    <div className={styles["web-modal"]}>
      <Modal show={visible} closeListener={onCancelInternal} includeCloseX={false}>
        <h2 className="text-h2">Make it your own</h2>
        <p className="body-medium">
          Editing this Applet will convert it to one of your own created
          Applets. It will allow you to add, change, or delete its triggers,
          queries, and actions.
        </p>
        <div className={styles.ctas}>
          <button
            type="button"
            className="button-tertiary button-cancel-link"
            onClick={onCancelInternal}
          >
            Cancel
          </button>
          <button
            type="button"
            className="button-tertiary"
            onClick={() => {
              onConvert?.()
              onClose()
            }}
          >
            Convert
          </button>
        </div>
      </Modal>
    </div>
  )
}

MakeItYourOwnModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConvert: PropTypes.func,
  onCancel: PropTypes.func,
}

export default MakeItYourOwnModal
